import React, { useEffect } from 'react'
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchCounts } from '../../redux/slices/siteDetailSlice';
import { fetchVendorDashboardStats } from '../../redux/slices/userSlice';

const UnitCountOne = () => {

    const dispatch = useDispatch();
    const { counts, loading } = useSelector((state) => state.siteDetail);
    const { stats } = useSelector((state) => state.users);
    const { user } = useSelector((state) => state.auth);
    const role = user?.role;

    useEffect(() => {
        dispatch(fetchCounts());
        dispatch(fetchVendorDashboardStats());
    }, [dispatch]);

    return (

        <>

            {
                role === "vendor" ? (

                    <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-1 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">New Appointments</p>
                                            <h6 className="mb-0">{stats.newAppointments || 0}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="gridicons:multiple-users"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}
                        </div>

                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-2 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Pending Bookings
                                            </p>
                                            <h6 className="mb-0">{stats.pendingBookings || 0}</h6>
                                        </div>

                                        <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="fa-solid:award"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}
                        </div>

                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-3 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Confirmed Bookings
                                            </p>
                                            <h6 className="mb-0">{stats.confirmedBookings || 0}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="fluent:people-20-filled"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}

                        </div>

                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-3 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Total Reviews
                                            </p>
                                            <h6 className="mb-0">{stats.totalReviews || 0}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="fluent:people-20-filled"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}

                        </div>

                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-3 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Total Bills
                                            </p>
                                            <h6 className="mb-0">{stats.totalBills || 0}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="fluent:people-20-filled"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}

                        </div>


                    </div>

                ) : (

                    <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-1 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">Total Users</p>
                                            <h6 className="mb-0">{counts.users || 0}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="gridicons:multiple-users"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}
                        </div>
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-2 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Total Vendor
                                            </p>
                                            <h6 className="mb-0">{counts.vendor?.total || 0}</h6>
                                        </div>
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Verfied Vendor
                                            </p>
                                            <h6 className="mb-0 text-primary">{counts.vendor?.verified || 0}</h6>
                                        </div>
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Unverfied Vendor
                                            </p>
                                            <h6 className="mb-0 text-danger">{counts.vendor?.unverified || 0}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="fa-solid:award"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}
                        </div>

                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-3 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">
                                                Total Bookings
                                            </p>
                                            <h6 className="mb-0">{counts.bookings || 0}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon
                                                icon="fluent:people-20-filled"
                                                className="text-white text-2xl mb-0"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* card end */}



                        </div>


                    </div>

                )
            }


        </>





    )
}

export default UnitCountOne